"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forManager = function (program, progress) {
    var isOwnerEligibleForAward = program.isOwnerEligibleForAward;
    var _a = progress.finalResult, totalNumberofPaxWhoAchievedGoal = _a.totalNumberofPaxWhoAchievedGoal, managerRange = _a.managerRange;
    var mgrEligYN = isOwnerEligibleForAward ? 'Y' : 'N';
    var multiPaxYN = totalNumberofPaxWhoAchievedGoal > 1 ? 'Y' : (totalNumberofPaxWhoAchievedGoal == 1 ? 'N' : 'X');
    var mgrRangeYN = managerRange ? 'Y' : 'N';
    return "" + mgrEligYN + multiPaxYN + mgrRangeYN;
};
exports.forGoalquest = function (program, progress) {
    var isMinimumQualifierEnabled = program.isMinimumQualifierEnabled, isBonusEnabled = program.isBonusEnabled;
    var bonusPayout = progress.bonusPayout;
    var _a = progress.finalResult, isGoalAchieved = _a.isGoalAchieved, isMQAchieved = _a.isMQAchieved, isBonusAchieved = _a.isBonusAchieved;
    var isGoalNeedToAchieve = bonusPayout ? bonusPayout.isGoalNeedToAchieve : '';
    var goalYN = isGoalAchieved ? 'Y' : 'N';
    var mqYN = isMinimumQualifierEnabled ? (isMQAchieved ? 'Y' : 'N') : 'X';
    var bonusYN = isBonusEnabled ? (isBonusAchieved ? 'Y' : 'N') : 'X';
    var bonusCoupledYN = isBonusEnabled ? (isGoalNeedToAchieve ? 'Y' : 'N') : 'X';
    return "" + goalYN + mqYN + bonusYN + bonusCoupledYN;
};
exports.forChallengepoint = function (program, progress) {
    var isBonusEnabled = program.isBonusEnabled;
    var bonusPayout = progress.bonusPayout;
    var _a = progress.finalResult, isGoalAchieved = _a.isGoalAchieved, isBonusAchieved = _a.isBonusAchieved;
    var earnedToDate = progress.goalProgress.earnedToDate;
    var isGoalNeedToAchieve = bonusPayout ? bonusPayout.isGoalNeedToAchieve : '';
    var goalYN = isGoalAchieved ? 'Y' : 'N';
    var earnedBaseEarningsYN = earnedToDate > 0 ? 'Y' : 'N';
    var bonusYN = isBonusEnabled ? (isBonusAchieved ? 'Y' : 'N') : 'X';
    var bonusCoupledYN = isBonusEnabled ? (isGoalNeedToAchieve ? 'Y' : 'N') : 'X';
    return "" + goalYN + earnedBaseEarningsYN + bonusYN + bonusCoupledYN;
};
exports.forObjective = function (program, progress) {
    var isMinimumQualifierEnabled = program.isMinimumQualifierEnabled;
    var _a = progress.finalResult, isGoalAchieved = _a.isGoalAchieved, isMQAchieved = _a.isMQAchieved;
    var goalYN = isGoalAchieved ? 'Y' : 'N';
    var mqYN = isMinimumQualifierEnabled ? (isMQAchieved ? 'Y' : 'N') : 'X';
    return "" + goalYN + mqYN;
};
//# sourceMappingURL=result-codes.js.map